import { render, staticRenderFns } from "./AppointmentStatusField.vue?vue&type=template&id=20d7d0ec&scoped=true&"
import script from "./AppointmentStatusField.vue?vue&type=script&lang=js&"
export * from "./AppointmentStatusField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d7d0ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20d7d0ec')) {
      api.createRecord('20d7d0ec', component.options)
    } else {
      api.reload('20d7d0ec', component.options)
    }
    module.hot.accept("./AppointmentStatusField.vue?vue&type=template&id=20d7d0ec&scoped=true&", function () {
      api.rerender('20d7d0ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/components/fields/AppointmentStatusField.vue"
export default component.exports